<template>
  <div class="cta-card">

    <!-- Esquerda: ícone de posição -->
    <div class="cta-pos-badge" :class="'cta-pos-' + (callAciont.position || 'bottom')">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="8" width="18" height="8" rx="4" stroke="currentColor" stroke-width="2"/>
      </svg>
      <span>{{ positionLabel }}</span>
    </div>

    <!-- Centro: texto e link -->
    <div class="cta-info">
      <div class="cta-text">{{ callAciont.text }}</div>
      <div class="cta-link">
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke="#94a3b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="#94a3b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ callAciont.link }}</span>
      </div>
    </div>

    <!-- Tempo -->
    <div class="cta-time">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#94a3b8" stroke-width="1.5"/><path d="M12 6v6l4 2" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"/></svg>
      <span class="cta-time-start">{{ convertSecondsToTime(callAciont.start) }}</span>
      <span class="cta-time-sep">→</span>
      <span v-if="callAciont.end !== 'Infinito'" class="cta-time-end">{{ convertSecondsToTime(callAciont.end) }}</span>
      <span v-else class="cta-time-end cta-time-inf">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M12 12c-2-2.5-4-4-6-4a4 4 0 000 8c2 0 4-1.5 6-4z" stroke="#94a3b8" stroke-width="1.5"/><path d="M12 12c2 2.5 4 4 6 4a4 4 0 000-8c-2 0-4 1.5-6 4z" stroke="#94a3b8" stroke-width="1.5"/></svg>
      </span>
    </div>

    <!-- Ações -->
    <div class="cta-actions">
      <button class="cta-btn-edit" @click="$emit('editar')" title="Editar">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </button>
      <button class="cta-btn-delete" @click="$emit('deleted')" title="Excluir">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><polyline points="3 6 5 6 21 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6M10 11v6M14 11v6M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'CallActionItem',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    callAciont: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    positionLabel() {
      const map = {
        top: 'TOPO',
        bottom: 'BASE',
        center: 'CENTRO',
        left: 'ESQ',
        right: 'DIR',
      }
      return map[this.callAciont.position] || (this.callAciont.position || 'BASE').toUpperCase()
    },
  },
  methods: {
    convertSecondsToTime(seconds) {
      if (seconds === 'Infinito') return false
      if (typeof seconds === 'string') return seconds
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const remainingSeconds = seconds % 60
      const formattedHours = String(hours).padStart(2, '0')
      const formattedMinutes = String(minutes).padStart(2, '0')
      const formattedSeconds = String(remainingSeconds).padStart(2, '0')
      if (hours > 0) return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
      return `${formattedMinutes}:${formattedSeconds}`
    },
  },
}
</script>

<style scoped>
.cta-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--dk-bg-card, #fff);
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-radius: 12px;
  padding: 12px 14px;
  transition: box-shadow 0.15s, border-color 0.15s;
}
.cta-card:hover {
  border-color: #E86A10;
  box-shadow: 0 2px 12px rgba(232,106,16,0.10);
}

/* Position badge */
.cta-pos-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  flex-shrink: 0;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.05em;
}
.cta-pos-badge span { line-height: 1; }
.cta-pos-top    { background: #fff7ed; color: #ea580c; }
.cta-pos-bottom { background: #eff6ff; color: #2563eb; }
.cta-pos-center { background: #fdf4ff; color: #9333ea; }
.cta-pos-left   { background: #f0fdf4; color: #16a34a; }
.cta-pos-right  { background: #fef2f2; color: #dc2626; }

/* Info */
.cta-info {
  flex: 1;
  min-width: 0;
}
.cta-text {
  font-size: 13px;
  font-weight: 700;
  color: var(--dk-text-primary, #0D3349);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 3px;
}
.cta-link {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: var(--dk-text-muted, #94a3b8);
}
.cta-link span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
}

/* Time */
.cta-time {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--dk-text-secondary, #64748b);
  background: var(--dk-bg-segment, #F4F6F9);
  border-radius: 8px;
  padding: 5px 9px;
  white-space: nowrap;
  flex-shrink: 0;
}
.cta-time-sep { color: var(--dk-text-faint, #c0c8d4); font-size: 10px; }
.cta-time-inf { display: flex; align-items: center; }

/* Action buttons */
.cta-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}
.cta-btn-edit, .cta-btn-delete {
  width: 32px; height: 32px;
  border-radius: 8px;
  border: 1.5px solid var(--dk-border, #E4EAF0);
  background: var(--dk-bg-page, #F8FAFB) !important;
  background-image: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
}
.cta-btn-edit { color: var(--dk-text-secondary, #64748b); }
.cta-btn-edit:hover { background: #eff6ff !important; border-color: #2563eb; color: #2563eb; }
.cta-btn-delete { color: var(--dk-text-muted, #94a3b8); }
.cta-btn-delete:hover { background: #fef2f2 !important; border-color: #dc2626; color: #dc2626; }
</style>
